function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M219.7 49.6V14.2h-28.4v35.4H92.1V14.2H63.8v35.4H0v70.9h28.3V78h35.5v162.9H28.3v28.4h99.3v-28.4H92.1V78h35.5v42.5h28.3V78h35.4v162.9h-35.4v28.4h99.2v-28.4h-35.4V78h35.4v42.5h28.4V49.6z"
})));